export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').slideToggle(speed);
    $(this).toggleClass('main-nav-mobile-button-active');
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).addClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  // Styleguide nav
  $('.sg-nav-mobile-button').click(function () {
    $('.js-sg-nav').slideToggle(speed);
  });
}
